import type { ApiType } from '@mira/api/app'
import { hc } from 'hono/client'

/** Typed API client. Request/response types come straight from the Hono routes. */
export const api = hc<ApiType>('/api', { init: { credentials: 'same-origin' } })
